export const fileExtensionList = ['mp4', 'mov', 'webm', 'mkv', 'png', 'jpg', 'jpeg', 'gif']

export const videoFileExtensionList = ['mp4', 'mov', 'webm', 'mkv']

export const photoFileExtensionList = ['png', 'jpg', 'jpeg', 'gif']

export const getFileType = (fileExtension) => {
  const videoExtensionList = new Set(videoFileExtensionList);

  const photoExtensionList = new Set(photoFileExtensionList);

  if (photoExtensionList.has(fileExtension.toLowerCase())) {
    return "image";
  }

  if (videoExtensionList.has(fileExtension.toLowerCase())) {
    return "video";
  }
};
